import { EUserStatus } from './userStatus';
import { TSetNewAnswerFormOpenPayload } from '../../actions/newAnswer/openFormActions';

export enum ENewAnswerModalStep {
  Answer = 'answer',
  Success = 'success',
  Error = 'error',
}

export interface INewAnswer {
  meta: {
    openId: TSetNewAnswerFormOpenPayload | null;
    step: ENewAnswerModalStep;
  };
  data: {
    name: string | null;
    userStatus: EUserStatus | null;
    answer: string;
    isAnonymous: boolean | null;
    error: string;
  };
}
